<template>
  <div
    class="flex items-center gap-2 text-sm font-semibold"
    :class="{
      'text-green-700': stock > 10 || availableWithAnyStock,
      'text-red-700': stock <= 5 && !availableWithAnyStock,
      'text-yellow-700': stock > 5 && stock <= 10 && !availableWithAnyStock,
    }"
  >
    <span v-if="availableWithAnyStock || stock > 10">
      {{ $t('product.stock.available') }}
    </span>
    <span v-else-if="stock <= 5">
      {{ $t('product.stock.unavailable') }}
    </span>
    <span v-else-if="stock <= 10">
      {{ $t('product.stock.lowStock') }}
    </span>
  </div>
</template>

<script setup lang="ts">
import type { Schemas } from '#shopware'

const props = defineProps<{
  product: Schemas['Product']
}>()

const stock = computed(() => props.product.availableStock)
const availableWithAnyStock = computed(
  () =>
    props.product.customFields?.novu_jp_custom_products_available_with_any_stock
)
</script>
